module.exports = __webpack_public_path__ + "static/moshi-709ce42eda8e1424660b98b0359541c9.png";